import BaseModel from "../models/_BaseModel";
import { DataFormFieldType, FormModalType } from "../utils/Types";
import ApiCaller from "../utils/ApiTemplate";
import GenericModal from "./GenericModal";

function FormModal<T extends BaseModel>(props: FormModalType<T>) {
    const {
        title,
        data,
        fields,
        apiCaller,
        onClose,
        onSave,
        onValidate
    } = props;

    return (
        <GenericModal
            apiCaller={apiCaller}
            data={data}
            title={title}
            fields={fields}
            onClose={onClose}
            onSave={onSave}
            onValidate={onValidate}
        />
    );
}

export default FormModal;
